import { Select, SelectProps } from "@mantine/core"
import { LogLevel } from "./LogLevel"

const logLevel_AllValues = ["Information", "Warning", "Error", "Debug"]

interface LogLevelSelectProps
  extends Omit<SelectProps, "data" | "rejderOption"> {}

export function LogLevelSelect(props: LogLevelSelectProps) {
  return (
    <Select
      placeholder="Lvl"
      withScrollArea={false}
      clearable
      data={logLevel_AllValues}
      renderOption={(item) => (
        <LogLevel withText value={item.option.value as LogLevel} />
      )}
      {...props}
    />
  )
}
